import {
  ADD_RFID_CARD_OPERATION_REQUEST,
  ADD_RFID_CARD_OPERATION_SUCCESS,
  ADD_RFID_CARD_OPERATION_FAIL,
  UPDATE_RFID_CARD_OPERATION_REQUEST,
  UPDATE_RFID_CARD_OPERATION_SUCCESS,
  UPDATE_RFID_CARD_OPERATION_FAIL,
  GET_RFID_CARD_OPERATION_LIST_REQUEST,
  GET_RFID_CARD_OPERATION_LIST_SUCCESS,
  GET_RFID_CARD_OPERATION_LIST_FAIL,
  GET_SINGLE_RFID_CARD_OPERATION_REQUEST,
  GET_SINGLE_RFID_CARD_OPERATION_SUCCESS,
  GET_SINGLE_RFID_CARD_OPERATION_FAIL,
} from "src/constants/types";

export const rfidCardOperationReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_RFID_CARD_OPERATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_RFID_CARD_OPERATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCardOperations: actions.payload,
        error: "",
      };

    case GET_RFID_CARD_OPERATION_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_RFID_CARD_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_SINGLE_RFID_CARD_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCardOperation: actions.payload,
      };

    case GET_SINGLE_RFID_CARD_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_RFID_CARD_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case ADD_RFID_CARD_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case ADD_RFID_CARD_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_RFID_CARD_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case UPDATE_RFID_CARD_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case UPDATE_RFID_CARD_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
